import React, { useState, useReducer, useEffect } from "react"
import {
  Card,
  Row,
  Col,
  Button,
  Select,
  Upload,
  Typography,
  Space,
  Alert,
  Spin,
  message,
} from "antd"
import { UploadOutlined, FileImageOutlined } from "@ant-design/icons"
import GridFiles from "components/Common/GridFilesAnt"
import FilePondUpload from "components/Common/FilePondUpload"
import { getCurrentUser, enumToArray } from "helpers/service_helper"
import { FileGasProjectType } from "models/types/file-gas-project-type"
import { getGasProjectFile } from "helpers/backend_helper"

const { Text, Title } = Typography

export const ProjectFiles = ({ rowData, mainProps, openNotification }) => {
  const [files, setFiles] = useState([])
  const [lstGasProjectFiles, setLstGasProjectFiles] = useState([])
  const [filesLoading, setFilesLoading] = useState(false)
  const [uploadLoading, setUploadLoading] = useState(false)
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      idGasProject: rowData?.id,
      fileTypeEnum: 2,
    }
  )
  const [fileGasProjectTypes, setFileGasProjectTypes] = useState([])

  const loadProjectFiles = async () => {
    if (!rowData?.id) return
    
    setFilesLoading(true)
    try {
      const response = await getGasProjectFile(rowData.id)
      setLstGasProjectFiles(response || [])
    } catch (error) {
      message.error("خطا در دریافت فایل‌ها")
    } finally {
      setFilesLoading(false)
    }
  }

  useEffect(() => {
    setFileGasProjectTypes(enumToArray(FileGasProjectType))
    loadProjectFiles()
  }, [rowData?.id])

  const handleInput = value => {
    setFormInput({ fileTypeEnum: value })
  }

  const saveToDatabase = async values => {
    const { onAddFileGasProjectSingle } = mainProps
    let file = files[0].file
    const fileName = FileGasProjectType[values.fileTypeEnum]
    let formData = new FormData()
    formData.append(
      "file",
      file,
      fileName + "." + file.name.split(".")[file.name.split(".").length - 1]
    )
    formData.append("gasProjectId", JSON.stringify([values.idGasProject]))
    formData.append("name", "gas-" + fileName)
    formData.append("des", `Upload with-${getCurrentUser().sid}`)
    formData.append("fileTypeEnum", fileName)
    formData.append("FolderName", "GasProjects")
    formData.append(
      "FileName",
      fileName + "." + file.name.split(".")[file.name.split(".").length - 1]
    )
    formData.append("userId", getCurrentUser().sid)
    formData.append("toUserId", getCurrentUser().sid)

    setUploadLoading(true)
    try {
      await onAddFileGasProjectSingle(formData)
      setFiles([])
      await loadProjectFiles()
      message.success("فایل با موفقیت بارگذاری شد")
    } catch (error) {
      message.error("خطا در بارگذاری فایل")
    } finally {
      setUploadLoading(false)
    }
  }

  const handleSubmitForm = async () => {
    if (formInput.idGasProject && files[0]) {
      await saveToDatabase(formInput)
    } else {
      message.warning("برای ذخیره ابتدا فایل را بارگذاری کنید")
    }
  }

  // Filter file types for executor
  const filteredFileTypes = fileGasProjectTypes.filter(
    row => row.id !== 0 && row.id !== 3 && row.id !== 5 && row.id !== 6
  )

  return (
    <div>
      {/* File List */}
      <Card
        title={
          <Space>
            <FileImageOutlined />
            <span>فایل‌های پرونده</span>
          </Space>
        }
        size="small"
        style={{ marginBottom: 16 }}
      >
        <Spin spinning={filesLoading}>
          <GridFiles lstGasProjectFiles={lstGasProjectFiles} props={mainProps} />
        </Spin>
      </Card>

      {/* Upload Section - Only show if project is not approved */}
      {(rowData?.projectLevelEnum !== 2 ||
        getCurrentUser().role === "Administrator") && (
        <Card
          title={
            <Space>
              <UploadOutlined />
              <span>بارگذاری فایل جدید</span>
            </Space>
          }
          size="small"
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} md={8}>
              <Text type="secondary" style={{ display: "block", marginBottom: 8 }}>
                نوع فایل
              </Text>
              <Select
                style={{ width: "100%" }}
                value={formInput.fileTypeEnum}
                onChange={handleInput}
                placeholder="انتخاب نوع فایل"
              >
                {filteredFileTypes.map(row => (
                  <Select.Option key={row.id} value={row.id}>
                    {mainProps.t("enums." + row.name)}
                  </Select.Option>
                ))}
              </Select>
            </Col>

            <Col xs={24}>
              <FilePondUpload
                setFiles={setFiles}
                maxFileSize="800KB"
                allowMultiple={false}
                maxFiles={1}
                acceptedFileTypes={["image/png", "image/jpeg"]}
                imagePreviewMaxHeight={600}
                labelText={`${mainProps.t(
                  "enums." + FileGasProjectType[formInput.fileTypeEnum]
                )} را اینجا بکشید`}
                waterMark={false}
              />
            </Col>

            <Col xs={24}>
              <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={handleSubmitForm}
                loading={uploadLoading}
                disabled={!files.length}
              >
                ذخیره فایل
              </Button>
            </Col>
          </Row>
        </Card>
      )}

      {rowData?.projectLevelEnum === 2 && (
        <Alert
          message="نقشه تایید شده است"
          type="success"
          showIcon
          style={{ marginTop: 16 }}
        />
      )}
    </div>
  )
}

export default ProjectFiles
